/**
 * A machine's upgrades, a page of its Values sheet (InfoSheet.tsx): a card per level in a strip,
 * its current one in the middle and marked, the next with its Upgrade button, and the level after
 * its last coming soon. All from its track (game/upgrade/upgrades.ts).
 */
import type { MachineType } from '@bramvasterd/terrella-rules';
import type { JSX } from 'react';

import { upgradeTrack } from '@game/upgrade/upgrades';
import { t } from '@i18n/index';
import type { HexLook } from '@ui/art/hexArt';
import { CardStrip } from '@ui/components/CardStrip';
import { useGame } from '@ui/hooks';

import { pictureGround } from '../build/blueprintText';
import { LevelCard } from './LevelCard';
import { SoonCard } from './SoonCard';

export function UpgradesPage({
  tile,
  type,
  name,
}: {
  tile: number;
  type: MachineType;
  name: string;
}): JSX.Element | null {
  const game = useGame();
  const track = upgradeTrack(game, tile);
  if (!track) return null;
  const look: HexLook = { tile: pictureGround(type), machine: type };
  return (
    <CardStrip
      label={t('upgrade.title')}
      focus={track.levels.findIndex((level) => level.state === 'current')}
    >
      {track.levels.map((level) => (
        <li key={level.level}>
          <LevelCard
            level={level}
            stats={track.stats}
            upgrade={track.upgrade}
            look={look}
            tile={tile}
            name={name}
          />
        </li>
      ))}
      {track.comingSoon !== null && (
        <li>
          <SoonCard level={track.comingSoon} stats={track.stats} look={look} />
        </li>
      )}
    </CardStrip>
  );
}
